import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CmsConfig, I18nModule, provideConfig, RoutingModule, UrlModule } from '@spartacus/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormErrorsModule } from '@spartacus/storefront';
import { AtgDraftOrderDetailHeaderComponent } from './atg-draft-order-detail-header/atg-draft-order-detail-header.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { KnBrDirectiveModule } from 'src/shared/directive/kn-br-directive.module';


@NgModule({
  declarations: [AtgDraftOrderDetailHeaderComponent],
  imports: [
    CommonModule,
    RouterModule,
    I18nModule,
    FormsModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    NgbModule,
    RoutingModule,
    UrlModule,
    FormErrorsModule,
    NgSelectModule,
    KnBrDirectiveModule,
  ],
    providers: [
      provideConfig({
        cmsComponents: {
          KnBrDraftOrderHeaderComponent: {
            component: () => import('./atg-draft-order-detail-header/atg-draft-order-detail-header.component').then((c) => c.AtgDraftOrderDetailHeaderComponent),
          },
          KnBrDraftOrderHeaderComponentReadOnly: {
            component: () => import('./atg-draft-order-detail-header/atg-draft-order-detail-header.component').then((c) => c.AtgDraftOrderDetailHeaderComponent),
          },
        },
      } as CmsConfig),
    ],   
  exports: [AtgDraftOrderDetailHeaderComponent],
})
export class AtgDraftOrderDetailsModule { }
